import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loader from 'react-loader';

import {fetchArticleFromElementConcept} from '../../articles/actions';

import {browserHistory} from 'react-router';
import {articleIndexRoute, homeRoute} from '../../../constants/public-routes';
import {getIdFromRelation} from "../../app/selectors";

const STATUS = {
  UNLOADED: 'UNLOADED',
  FOUND: 'FOUND',
  DIFFERENT: 'DIFFERENT',
  ERROR: 'ERROR',
};

class ConceptContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      status: STATUS.UNLOADED
    };

    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
    this.retrieveError = this.retrieveError.bind(this);
  }

  componentDidMount() {
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps, this.props.conceptId);
  }

  fetchIfNeeded(props, oldConceptId = null) {
    let {fetchArticleFromElementConcept, language, queryLanguage, conceptId, article} = props;
    let {retrieveError} = this;
    if (!article.item) {
      return retrieveError();
    }
    let articleId = article.item.id;
    if (articleId) {
      let structureId = getIdFromRelation(article.item, 'structure');
      if (article.item.attributes.canonical_element === conceptId) {
        this.setState({status: STATUS.FOUND});
        browserHistory.push(articleIndexRoute(language, structureId, articleId));
      } else {
        this.setState({status: STATUS.DIFFERENT});
        browserHistory.push(articleIndexRoute(language, structureId, articleId));
      }
    }
    if (conceptId !== oldConceptId) {
      fetchArticleFromElementConcept(conceptId, queryLanguage).catch(retrieveError);
    }
  }

  retrieveError() {
    let {language} = this.props;
    this.setState({status: STATUS.ERROR});
    setTimeout(() => {
      browserHistory.push(homeRoute(language));
    }, 1000);
  }

  render() {
    let messages = {
      [STATUS.UNLOADED]: 'Retrieving the latest article',
      [STATUS.FOUND]: 'Found the article, redirecting',
      [STATUS.DIFFERENT]: 'Found a different article, redirecting',
      [STATUS.ERROR]: 'An error occurred, redirecting to the home page',
    };
    let {status} = this.state;
    return (
      <div>
        <p>{messages[status]}&hellip;</p>
        <Loader loaded={false}/>
      </div>
    );
  }

}

ConceptContainer.propTypes = {
  fetchArticleFromElementConcept: React.PropTypes.func,
  language: React.PropTypes.string,
  queryLanguage: React.PropTypes.string,
  conceptId: React.PropTypes.string,
  article: React.PropTypes.object,
};


function mapDispatchToProps(dispatch) {
  return {
    fetchArticleFromElementConcept: bindActionCreators(fetchArticleFromElementConcept, dispatch)
  };
}

function mapStateToProps(state, ownProps) {
  let {lang, conceptId} = ownProps.params;
  let queryLanguage = lang;
  if (ownProps.location.query.lang) {
    queryLanguage = ownProps.location.query.lang;
  }
  let {article} = state;
  return {language: lang, queryLanguage, conceptId, article};
}

export default connect(mapStateToProps, mapDispatchToProps)(ConceptContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/concepts/containers/ConceptContainer.js
 **/